import React from 'react';
import WhatsNewView from './WhatsNewView';

const WhatsNewPage: React.FC = () => <WhatsNewView />;

export default WhatsNewPage;
